import { useNavigate } from "react-router-dom";
import StarIcon from '../../../../assets/images/icons/start-icon.svg';
import RandomActionsButton from "../../../../components/RandomActionsButon";

function InsightSection({ topTrack, hasActiveSubscription, onProClick }) {
  const navigate = useNavigate()

  const handleNavigation = (action) => {
    navigate(action)
  }
  return (
    <div className="info-box h-full bg-theme_clr1 text-white rounded-xl p-4 xl:p-5">
      <div className="title-info text-[23px] font-bold font-manrope flex items-center gap-2 leading-tight mb-6">
        <img
          src={require("../../../../assets/images/admin/Amplitude-Info.png")}
          alt="Amplitude Info"
          className="w-[30px] h-[30px]"
        />
        Amplitude Insight
      </div>
      <div className="desc-wrapper flex flex-col gap-6">
        {hasActiveSubscription ?
          <RandomActionsButton count={3}/> :
          <div className="flex flex-col items-center">
            <p className="text-white">Click on "Go Pro" to see your data</p>
            <button
              type="button"
              className={`btn-custom3 flex items-center text-center gap-2`}
              onClick={onProClick}
            >
              Go Pro
              <img
                src={StarIcon}
                alt="Star"
                className="h-[20px] w-[20px] min-w-[20px]"
              />
            </button>
          </div>
        }
      </div>
    </div>
  );
}

export default InsightSection;
